// 'bracket' 영역 문구. 키는 ko / en 에 똑같이 둔다.

function englishOrdinal(n) {
  const value = Number(n);
  const mod100 = value % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${value}th`;
  const suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[value % 10] ?? 'th';
  return `${value}${suffix}`;
}

const bracket = {
  ko: {
    matchNo: '{no}번',
    matchNoAria: '경기 {no}번',
    roundRange: ' ({start}~{end}번)',
    roundRangeSingle: ' ({start}번)',
    winnerAdvances: '승자 진출',
    champion: '우승',
    win: '승',
    loss: '패',
    draw: '무',
    score: {
      head: '머리',
      body: '몸통',
      total: '최종',
    },
    startMatch: '▶ 경기 시작',
    endMatch: '■ 경기 종료',
    enterScore: '✏️ 점수 입력',
    editScore: '✏️ 점수 수정',
    bracketSize: '{size}강',
    matchCount: '{count}경기',
    noPlayer: '선수 없음',
    matchList: {
      empty: '경기가 없습니다.',
      emptyEdit: '경기가 없습니다. 「자동 짝 추가」나 「경기 추가」로 경기를 만들어 주세요.',
      addPairs: '+ 자동 짝 추가',
      addPairsTitle: '이 부문 선수들이 한 경기씩 더 하도록 짝을 만듭니다 (이미 붙은 상대는 되도록 피함)',
      addMatch: '+ 경기 추가',
      selectPlayer: '선수 선택',
      player1: '{no}번 경기 선수 1',
      player2: '{no}번 경기 선수 2',
      moveUp: '위로',
      moveDown: '아래로',
      remove: '{no}번 경기 삭제',
      unpaired: '아직 경기가 없는 선수: {names}',
    },
    empty: {
      height:
        '키별 대진을 표시할 수 없습니다. 키 범위를 설정하고 각 구간에 참가자가 2명 이상인지 확인해 주세요.',
      gender: '남녀 분리 대진을 만들 수 없습니다. 각 성별에 참가자가 2명 이상 필요합니다.',
      default: '대진표를 표시할 수 없습니다.',
    },
    summary: {
      combined: '{size}강 대진표',
      division: '{label} {size}강',
      heightNeedsPlayers: '키별 분리 대진 (각 구간 2명 이상 필요)',
      heightNeedsRanges: '키별 분리 대진 (범위 설정 필요)',
      genderNotEnough: '남녀 분리 대진 (참가 인원 부족)',
      matches: '1:1 경기 {count}경기',
      matchesDivision: '{label} {count}경기',
    },
    results: {
      title: '🏆 토너먼트 결과',
      titleMatches: '🏆 경기 결과',
      rank: '{rank}위',
      matchLog: '경기 기록',
      scoreDetail: '{total} (머리 {head} · 몸통 {body})',
      record: '{wins}승 {losses}패',
      recordWithDraws: '{wins}승 {draws}무 {losses}패',
      draw: '무승부',
      undecided: '미정',
      col: {
        match: '경기',
        round: '라운드',
        player1: '선수 1',
        player2: '선수 2',
        score: '점수',
        winner: '승자',
        rank: '순위',
        name: '이름',
        gym: '도장',
        record: '전적',
        headTotal: '머리점수 합계',
        bodyTotal: '몸통점수 합계',
        finalTotal: '최종점수 합계',
      },
    },
    scoreModal: {
      win: '승',
      head: '머리점수',
      body: '몸통점수',
      total: '최종점수',
      hint:
        '라운드마다 머리·몸통 점수를 입력하면 최종점수는 자동 계산됩니다 (감점 등은 직접 수정). 승자는 자동으로 정해지지 않으니 직접 선택해 주세요.',
      noWinner: '승자 미정',
      draw: '무승부',
      invalidScore: '점수는 0~{max} 사이의 정수로 입력해 주세요.',
      clearScores: '점수 지우기',
      round: '라운드',
      roundNo: '{n}R',
      addRound: '+ 라운드 추가',
      removeRound: '{n}라운드 삭제',
      sum: '합계',
      maxRounds: '라운드는 최대 {max}개까지 입력할 수 있습니다.',
    },
    height: {
      selectEmpty:
        '표시할 키 구간이 없습니다. 범위를 설정하고 각 구간에 참가자가 2명 이상 있는지 확인해 주세요.',
      selectLabel: '키 구간 선택',
      editorTitle: '키 범위 설정',
      addRange: '+ 범위 추가',
      editorHint:
        '최소·최대 키(cm)를 입력하세요. 구간은 겹치지 않아야 하며, 각 구간에 2명 이상일 때 대진표가 생성됩니다.',
      min: '최소 (cm)',
      max: '최대 (cm)',
      removeRangeAria: '범위 삭제',
      remove: '삭제',
      apply: '범위 적용',
      noValidRange: '설정한 키 구간에 참가자가 2명 이상인 구간이 없습니다. 범위를 조정해 주세요.',
      confirmInsufficient:
        '{labels} 구간은 참가자가 2명 미만이라 대진표가 생성되지 않습니다.\n계속 적용하시겠습니까?',
      validation: {
        required: '키 범위를 1개 이상 추가해 주세요.',
        missingValues: '모든 키 범위에 최소·최대 값을 입력해 주세요.',
        outOfBounds: '키 범위는 1cm 이상 {max}cm 이하여야 합니다.',
        minGreaterThanMax: '최소 키는 최대 키보다 클 수 없습니다.',
        overlap: '키 범위가 서로 겹칩니다. 구간이 겹치지 않도록 설정해 주세요.',
      },
    },
    live: {
      panelAria: 'VR 진행 중인 경기',
      idle: 'VR 진행 중인 경기 없음',
      idleHint:
        '경기 칸의 「▶ 경기 시작」을 누르고 코트를 고르면 그 코트에서 경기가 진행됩니다. 여러 코트를 동시에 진행할 수 있습니다. 학생이 VR에서 핸드폰번호로 로그인하면 진행 중인 경기 중 그 학생의 경기를 찾아, 경기가 끝나면 점수와 승패를 그 경기에 저장합니다.',
      court: '{court}코트',
      checkedIn: 'VR 접속',
      waiting: '접속 대기',
      points: '{score}점',
      win: ' 승',
      loss: ' 패',
      draw: ' 무',
      otherTournamentHint:
        '다른 대회의 경기도 진행 중입니다. 같은 코트에서 이 대회 경기를 시작하면 그 경기는 종료됩니다.',
    },
    courtPicker: {
      title: '코트 선택',
      courtCount: '코트 수',
      free: '비어 있음',
      busy: '진행 중: {match}',
      hint:
        '진행 중인 코트를 고르면 그 코트의 경기가 이 경기로 바뀝니다. 같은 학생은 동시에 두 코트에서 경기할 수 없습니다.',
    },
  },
  en: {
    matchNo: '#{no}',
    matchNoAria: 'Match {no}',
    roundRange: ' (#{start}–{end})',
    roundRangeSingle: ' (#{start})',
    winnerAdvances: 'TBD',
    champion: 'Champion',
    win: 'W',
    loss: 'L',
    draw: 'D',
    score: {
      head: 'Head',
      body: 'Body',
      total: 'Total',
    },
    startMatch: '▶ Start match',
    endMatch: '■ End match',
    enterScore: '✏️ Enter score',
    editScore: '✏️ Edit score',
    bracketSize: 'Bracket of {size}',
    matchCount: ({ count }) => `${count} ${Number(count) === 1 ? 'match' : 'matches'}`,
    noPlayer: 'No player',
    matchList: {
      empty: 'There are no matches.',
      emptyEdit: 'There are no matches. Use "Auto-pair" or "Add match" to create matches.',
      addPairs: '+ Auto-pair',
      addPairsTitle:
        'Pairs everyone in this division for one more match (avoiding previous opponents where possible)',
      addMatch: '+ Add match',
      selectPlayer: 'Select player',
      player1: 'Match {no} player 1',
      player2: 'Match {no} player 2',
      moveUp: 'Move up',
      moveDown: 'Move down',
      remove: 'Remove match {no}',
      unpaired: 'Players without a match: {names}',
    },
    empty: {
      height:
        'Cannot display height brackets. Set height ranges and make sure each range has at least 2 participants.',
      gender:
        'Cannot create separate male/female brackets. Each gender needs at least 2 participants.',
      default: 'Cannot display the bracket.',
    },
    summary: {
      combined: 'Bracket of {size}',
      division: '{label} · Bracket of {size}',
      heightNeedsPlayers: 'Height brackets (each range needs 2+ participants)',
      heightNeedsRanges: 'Height brackets (set ranges first)',
      genderNotEnough: 'Male/female brackets (not enough participants)',
      matches: ({ count }) => `1:1 matches (${count})`,
      matchesDivision: ({ label, count }) => `${label} · ${count} ${Number(count) === 1 ? 'match' : 'matches'}`,
    },
    results: {
      title: '🏆 Tournament Results',
      titleMatches: '🏆 Match Results',
      rank: ({ rank }) => englishOrdinal(rank),
      matchLog: 'Match log',
      scoreDetail: '{total} (Head {head} · Body {body})',
      record: '{wins}W {losses}L',
      recordWithDraws: '{wins}W {draws}D {losses}L',
      draw: 'Draw',
      undecided: 'TBD',
      col: {
        match: 'Match',
        round: 'Round',
        player1: 'Player 1',
        player2: 'Player 2',
        score: 'Score',
        winner: 'Winner',
        rank: 'Rank',
        name: 'Name',
        gym: 'Gym',
        record: 'Record',
        headTotal: 'Head total',
        bodyTotal: 'Body total',
        finalTotal: 'Final total',
      },
    },
    scoreModal: {
      win: 'Win',
      head: 'Head score',
      body: 'Body score',
      total: 'Total score',
      hint:
        'Enter head and body scores for each round; the total is calculated automatically (edit it for penalties). The winner is not chosen automatically, so please select it.',
      noWinner: 'No winner',
      draw: 'Draw',
      invalidScore: 'Scores must be whole numbers from 0 to {max}.',
      clearScores: 'Clear scores',
      round: 'Round',
      roundNo: 'R{n}',
      addRound: '+ Add round',
      removeRound: 'Remove round {n}',
      sum: 'Total',
      maxRounds: 'You can enter up to {max} rounds.',
    },
    height: {
      selectEmpty:
        'No height ranges to display. Set ranges and make sure each range has at least 2 participants.',
      selectLabel: 'Height range',
      editorTitle: 'Height ranges',
      addRange: '+ Add range',
      editorHint:
        'Enter the minimum and maximum height (cm). Ranges must not overlap; a bracket is created for each range with 2 or more participants.',
      min: 'Min (cm)',
      max: 'Max (cm)',
      removeRangeAria: 'Remove range',
      remove: 'Remove',
      apply: 'Apply ranges',
      noValidRange: 'None of the ranges has 2 or more participants. Please adjust the ranges.',
      confirmInsufficient:
        'No bracket will be created for {labels} because they have fewer than 2 participants.\nApply anyway?',
      validation: {
        required: 'Add at least one height range.',
        missingValues: 'Enter a minimum and maximum for every height range.',
        outOfBounds: 'Height ranges must be between 1 cm and {max} cm.',
        minGreaterThanMax: 'The minimum height cannot be greater than the maximum.',
        overlap: 'Height ranges overlap. Please set ranges that do not overlap.',
      },
    },
    live: {
      panelAria: 'VR matches in progress',
      idle: 'No VR matches in progress',
      idleHint:
        'Press "▶ Start match" on a match and choose a court to run it on that court. Several courts can run at the same time. When a student logs in to VR with their phone number, their match is found among the matches in progress, and when it ends the scores and result are saved to it.',
      court: 'Court {court}',
      checkedIn: 'VR connected',
      waiting: 'Waiting',
      points: ({ score }) => `${score} ${Number(score) === 1 ? 'pt' : 'pts'}`,
      win: ' W',
      loss: ' L',
      draw: ' D',
      otherTournamentHint:
        'Matches from another tournament are also in progress. Starting a match from this tournament on the same court will end it.',
    },
    courtPicker: {
      title: 'Choose a court',
      courtCount: 'Number of courts',
      free: 'Free',
      busy: 'In progress: {match}',
      hint:
        'Choosing a busy court replaces its match with this one. A student cannot play on two courts at the same time.',
    },
  },
};

export default bracket;
